<template>
  <div class="aboutUs">
    <div class="title">
      <span>当前位置：&nbsp</span>
      <span>展会</span>
      <span>></span>
      <span>关于我们</span>
    </div>

    <div class="content">
      <div class="content_top">{{ title }}</div>
      <div class="textDiv" v-html="content">
        <!-- <p>《中国现代教育装备展》杂志社</p>
        <p>单位地址：北京市海淀区西直门北大街32号枫蓝国际中心B座910（1000082）</p>
        <p>投稿杂志：cn11_4994@263.net（高教）；cn11_4994@163.com（基教）</p>
        <p>杂志地址：http://www.zgxdjyzb.com</p>
        <p>联系电话：010-82098610</p>
        <div>
          <img src="../../assets/image/aboutUs.jpg" alt />
        </div>
        <p>北京教育装备展示会</p>
        <p>组委会地址：北京市海淀区西直门北大街32号枫蓝国际中心B座910（1000082）</p>
        <p>展会地址：http://www.cmee-online.com</p>
        <p>联系电话：010-82210085</p> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "aboutUs", // 关于我们
  data() {
    return {
      dataList: [],
      title: "",
      content: "",
    };
  },
  activated() {
    this.$http({
      url: "getInformationList",
      method: "post",
      params: {
        type: "16",
      },
    })
      .then(({ data }) => {
        let { code, informationByTypeList } = data;
        if (code === 0) {
          this.title = informationByTypeList[0].title;
          this.content = informationByTypeList[0].content;
        }
      })
      .catch((err) => console.log(err));
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.aboutUs {
  min-height: 1181px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 92px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 9px;
    }
  }
  .content {
    // width: 857px;
    min-height: 984px;
    margin: 10px auto 21px;
    .content_top {
      width: 1120px;
      font-size: 28px;
      color: #000000;
      font-weight: bold;
      text-align: center;
     /* height: 28px; */
      line-height: 45px;
      margin: 48px auto 0;
      padding-bottom: 34px;
      border-bottom: 1px solid #e5e5e5;
    }
    .textDiv {
      width: 896px;
      min-height: 650px;
      margin: 60px auto 60px;
      p {
        line-height: 49px;
        font-size: 18px;
        color: #333333;
        text-indent: 10px;
      }
      p:first-child {
        font-size: 19px;
        font-weight: bold;
      }
      div {
        width: 150px;
        height: 150px;
        margin: 30px 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>